import { render, staticRenderFns } from "./webcontent-option.vue?vue&type=template&id=6bcc300b&scoped=true&"
import script from "./webcontent-option.vue?vue&type=script&lang=js&"
export * from "./webcontent-option.vue?vue&type=script&lang=js&"
import style0 from "./webcontent-option.vue?vue&type=style&index=0&id=6bcc300b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcc300b",
  null
  
)

export default component.exports